import global from "../global.js";

const log = global.log.getLogger("f_mtac.users.androidApp");
log.setLevel(log.levels.WARN);

/**
 * @brief This module is responsible for the communication with the Android service managing
 * the geolocation of the user when the room is shared. It sends commands to the Android
 * service:
 * - are you here ?
 * - start geoloc
 * - stop geoloc
 */
const AndroidApp = function () {

    // android_service_started: true if the android geoloc service has been started with success
    let geo_started = false;
    
    Object.defineProperty(this, "geolocation_started", {
        set: () => {},
        get: () => geo_started
    });

    /**
     * @brief Send a command to start geolocation
     * @return true if success, false if failure
     */
    this.start_geolocation = async () => {

        try {

            
            log.debug("AndroidApp.start_geolocation in", global.storage.selected_space.room);
            // there is a share ongoing
        
            // check android service here
            const data = {
                device_id: global.server.registrar.user.login,
                server_url: global.configuration.server.address,
                desktop_id: "",
                space_id: global.storage.selected_space.room.space,
                interval: "10000"
            };
            
            const fetchData = {
                method: "POST",
                mode: "cors",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Origin": "http://localhost:8923"
                }
            };
            let response = await fetch("http://localhost:8923/start", fetchData)
                .then(response => {
                    log.debug("AndroidApp.start_geolocation response to fetch", response);
                    return response.json();
                })
                .then(data => {
                    geo_started = true;
                    log.debug("data", {data});
                    return data;
                })
                .catch((error) => {
                    log.debug("AndroidApp.start_geolocation Could not join the Android app", error);
                    geo_started = false;
                    return null;
                });

            log.debug("AndroidApp.start_geolocation Android response =", response);
            if (response != null && response.message === "OK") {
                geo_started = true;
                return true;
            }
            log.debug("AndroidApp.start_geolocation out false");
            return false;
        }
        catch(error) {
            log.debug("AndroidApp.start_geolocation Exception");
            return false;
        }
        
    };

    /**
     * @brief sends a command to stop geolocation
     */
    this.stop_geolocation = async () => {
        log.debug("AndroidApp.stop_geolocation in");
        
        try {
        
            const fetchData = {
                method: "POST",
                mode: "cors",
                body: "{}",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Origin": "http://localhost:8923"
                }
            };
            geo_started = false;
            let response = await fetch("http://localhost:8923/stop", fetchData)
                .then(response => {
                    log.debug("AndroidApp.stop_geolocation response to fetch", response);
                })
                .catch((error) => {
                    log.debug("AndroidApp.stop_geolocation Could not join the Android app", error);
                });
            log.debug("AndroidApp.check_service", response);
        }
        catch(error) {
            log.debug("AndroidApp.stop_geolocation Exception");
        }

    };

    /**
     * @brief Check if the android service is running
     * @returns true if status = 200, else false
     */
    this.check_service = async () => {
        log.debug("AndroidApp.check_service in");

        /*try {
        
            const fetchData = {
                method: "GET",
                mode: "cors",
                headers: {
                    "Origin": "http://localhost:8923"
                }
            };
            let success = await fetch("http://localhost:8923/ping", fetchData)
                .then(response => {
                    log.debug("AndroidApp.check_service response to fetch", response);
                    return response.status == 200;
                })
                .catch((error) => {
                    log.debug("Android App not reachable", error);
                    return false;
                });
            log.debug("AndroidApp.check_service", success);
            return success;
        }
        catch(error) {
            log.debug("AndroidApp.check_service Android service didn't answer");
        }*/
        return false;
    };

};

export default AndroidApp;